// extracted by mini-css-extract-plugin
export default {"titleWrapper":"titleWrapper__dXwt8b","infoIcon":"infoIcon__KtrAtB","sectionTitle":"sectionTitle__smiL3O","infoAlert":"infoAlert__jr4EE6","speakerList":"speakerList__GPRtsX"};